import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { ListItem } from './ListItem'
import { Footer } from './Footer'
import { ModalProdutos } from './components/Modais/ModalProdutos'
import { Header } from './Header'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'
import { Button } from '../../../components/Button'
import { Link } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Flex alignItems="center" justifyContent="center" px={10}>
      <Box bg="white" w="100%" maxW="1366px" mx="auto" px={4} pt={5} pb={5} mt={5} borderRadius="md" boxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
        <Text fontSize="16px" fontWeight="bold" color="red.500" textAlign="center" mt="10" mb="2">
          Desculpe, algo deu errado:
        </Text>
        <Text fontSize="16px" fontWeight="bold" textAlign="center">
          {error.message}
        </Text>
        <Button onClick={resetErrorBoundary}>Tentar novamente</Button>
      </Box>
    </Flex>
  )
}

export function NovoOrcamentoPedido() {
  const { infoProposta, itens, isError } = useOrcamentoPedido()

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload()
      }}
    >
      {!isError ? (
        <Box bg="white">
          <Box bg="white" position="relative">
            <Box bg="white" minH="100vh" fontSize="12px" fontFamily="Open Sans">
              <Box maxW="1366px" w="full" mx="auto" px={4} pt={5}>
                <Header infoProposta={infoProposta} itens={itens} />
                <Flex justifyContent="space-between" alignItems="center">
                  <>
                    {infoProposta?.perdido && (
                      <Badge colorScheme="red" p={2} borderRadius="md">
                        <Flex flexDir="column">
                          <Text>Este orçamento foi perdido</Text>
                          <Text fontSize="12px">Motivo: {infoProposta?.observacao_perda}</Text>
                        </Flex>
                      </Badge>
                    )}
                    {infoProposta?.valida_bloqueio && (
                      <Badge colorScheme="green" p={2} borderRadius="md">
                        Este orçamento já é pedido{' '}
                        <Text
                          as={Link}
                          color="blue.500"
                          textDecoration="underline"
                          _hover={{ color: 'blue.600' }}
                          to={`/vendas/gerar-pedido/${infoProposta?.numero_nota_link}`}
                        >
                          clique aqui para visualizar
                        </Text>
                      </Badge>
                    )}
                    {!infoProposta?.valida_proposta_nova ? (
                      <ModalProdutos infoProposta={infoProposta} itens={itens} />
                    ) : (
                      <Button my="3" display="flex" bgColor="red.500" ml="auto" cursor="not-allowed">
                        Preencha as informações acima para adicionar produtos
                      </Button>
                    )}
                  </>
                </Flex>

                <ListItem listItems={itens} {...infoProposta} />
              </Box>
            </Box>
          </Box>
          <Footer listItems={itens} numeroNota={infoProposta.num_proposta} />
        </Box>
      ) : (
        <Box bg="white" w="100%" maxW="1366px" mx="auto" px={4} pt={5} pb={5} mt={5} borderRadius="md" boxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
          <Text fontSize="16px" fontWeight="bold" color="red.500" textAlign="center" mt="10" mb="2">
            Desculpe, algo deu errado:
          </Text>
          <Text fontSize="16px" fontWeight="bold" textAlign="center">
            Não foi possível carregar as informações do orçamento
          </Text>
          <Button as={Link} to="/">
            Voltar para Home
          </Button>
        </Box>
      )}
    </ErrorBoundary>
  )
}
